import React, { useState, useEffect } from 'react'
import { Tree, Input } from 'antd'
import styled from 'styled-components'

const { Search } = Input
import { getCookie } from 'helper/cookie'
import { SearchOutlined } from '@ant-design/icons'
const HolidayContainer = styled.div``
import lang from 'lang/en'

const TreeComponent = (props) => {
  const {
    treeCompany,
    setLevel_ID,
    setLevel,
    eventAdd,
    setCompanyID,
    setCheckChangeTable,
    checkChangeTable,
    setParent_ID,
    openDefaultTree,
    resetBusinessQuery,
  } = props

  const token = getCookie('access_token_admin')
  const [expandedKeys, setExpandedKeys] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const [autoExpandParent, setAutoExpandParent] = useState(true)
  const language = getCookie('lang')
  const word = lang[language]
  const [selectedKeys, setSelectedKeys] = useState()
  const [companyData, setCompanyData] = useState(treeCompany?.[0]?.title);

  const [firsttimein, setfirsttimein] = useState(openDefaultTree)

  // const updateField = () => {
  //   const newTitle = { ...companyData, title: 'Business' };
  //   setCompanyData(newTitle);
  // }
  const newTitle = { ...treeCompany?.title, title: 'B' }
  // setCompanyData(newTitle);


  useEffect(() => {
    if (firsttimein == true) {
      setExpandedKeys(['key_company'])
      setSelectedKeys(['key_company'])
    } else {
      if (expandedKeys == [] || selectedKeys == []) {
        setExpandedKeys(['key_company'])
        setSelectedKeys(['key_company'])
      }
      setExpandedKeys(expandedKeys)
      setSelectedKeys(selectedKeys)
    }
  }, [treeCompany])

  const dataList = []
  //นำ data ที่เป็น tree มาแยกออกให้เป็นของตัวมันเอง
  const generateList = (data) => {
    for (let i = 0; i < data.length; i++) {
      const node = data[i]
      const { key } = node
      dataList.push({ key, title: key })
      if (node.children) {
        generateList(node.children)
      }
    }
  }
  generateList(treeCompany)

  const getParentKey = (key, tree) => {
    let parentKey
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children)
        }
      }
    }
    return parentKey
  }

  //จังหวะ click จะให้ตัวไหนเปิดบ้าง
  const onExpand = (expandedKeys) => {
    setfirsttimein(false)
    setExpandedKeys(expandedKeys)
    setAutoExpandParent(false)
  }

  const onChange = (e) => {
    const { value } = e.target
    const expandedKeys = dataList.map((item) => {
      if (item?.title?.toLowerCase()?.includes(value?.toLowerCase())) {
        //ถ้าคำตรงกันให้ไปหาตัวแม่ของมัน
        return getParentKey(item.key, treeCompany)
      }
      return null
    })

    setExpandedKeys(expandedKeys)
    setSearchValue(value)
    setAutoExpandParent(true)
  }

  const [checkSearch, setCheckSearch] = useState([])

  const [displayTree, setDisplayTree] = useState(true)

  let arr = []

  const checkDataSearch = async (data) => {
    await data.map((item) => {
      const index = item.title.toLowerCase().includes(searchValue.toLowerCase())
      arr.push(index)

      if (item.children) {
        return {
          key: item.key,
          children: checkDataSearch(item.children),
          level: item.level,
          level_id: item.level_id,
          id: item.id,
          item: item,
        }
      }
    })
    setCheckSearch(arr)
  }

  useEffect(() => {
    let havedata = false
    checkSearch.map((item) => {
      if (item == true) {
        havedata = true
      }
    })
    if (checkSearch.length == 0) {
      setDisplayTree(true)
    } else {
      setDisplayTree(havedata)
    }
  }, [checkSearch])

  useEffect(() => {
    arr = []
    checkDataSearch(treeCompany)
  }, [searchValue])

  const loop = (data) =>
    data.map((item) => {
      let split = item.title.split(' ')

      let code = split[0]

      let titletitle = []
      split.map((item, index) => {
        if (index != 0) {
          titletitle.push(item)
        }
      })

      let realtitle = titletitle.join(' ')

      const index = item.title.toLowerCase().includes(searchValue.toLowerCase())

      const title =
        item.title == 'Company' ? (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 4.5,
            }}
          >
            <h5>Business</h5>
          </span>
        ) : index == true && searchValue != '' ? (
          item.level == 1 ? (
            <span
              className='event-search-tree-container'
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: 4.5,
              }}
            >
              <h5 className='code-tree-style'>{code}</h5>
              <h5
                className='title-cut'
                style={{
                  marginLeft: 8,
                  background: 'rgba(18, 126, 195, 0.16)',
                  padding: '0px 4px 0px 4px',
                  borderRadius: 16,
                }}
              >
                {realtitle}
              </h5>
            </span>
          ) : (
            <p
              className='title-cut'
              style={{
                background: 'rgba(18, 126, 195, 0.16)',
                padding: '0px 4px 0px 4px',
                marginTop: 6,
                borderRadius: 16,
              }}
            >
              {item.title}
            </p>
          )
        ) : // ไม่เจอ
          item.level == 1 ? (
            <span
              className='event-search-tree-container'
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: 4.5,
              }}
            >
              <h5 className='code-tree-style'>{code}</h5>
              <h5 className='title-cut' style={{ marginLeft: 8 }}>
                {realtitle}
              </h5>
            </span>
          ) : (
            <p
              className='title-cut'
              style={{
                marginTop: 6,
              }}
            >
              {item.title}
            </p>
          )

      //ถ้ามี ใน item นั้นมี children ให้วนลูป ไปค้นหาใหม่
      if (item.children) {
        return {
          title,
          key: item.key,
          children: loop(item.children),
          level: item.level,
          level_id: item.level_id,
          id: item.id,
          item: item,
        }
      }

      return {
        title,
        key: item.key,
        level: item.level,
        level_id: item.level_id,
        id: item.id,
        item: item,
      }
    })

  const onClick = (e, value) => {
    if (value.item.level != 3) {
      setSelectedKeys([value.item.key])
    }

    setParent_ID(value.item.level_id)
    setCompanyID(value.item.id)

    let checkrepeat = false
    if (expandedKeys) {
      expandedKeys.map((item) => {
        if (item == value.item.key) {
          checkrepeat = true
        }
      })
      if (checkrepeat == false) {
        setExpandedKeys((prev) => [...prev, value.item.key])
      }
      setfirsttimein(false)
    } else {
      setExpandedKeys((prev) => [...prev, value.item.key])
    }

    //คลิ๊กที่ company
    if (value.item.level == 0 && value.item.level_id == 0) {
      if (resetBusinessQuery) resetBusinessQuery()
      setLevel(1)
      setLevel_ID(value.item.level_id)
      setCheckChangeTable(checkChangeTable + 1)
    }
    //คลิ๊กที่ ชื่อcompany
    else if (value.item.level == 1 && value.item.level_id == 0) {
      if (resetBusinessQuery) resetBusinessQuery()
      setLevel(2)
      setLevel_ID(value.item.id)
      setCheckChangeTable(checkChangeTable + 1)

      //คลิ๊กที่ ชื่อoperation
    } else if (value.item.level == 2) {
      setLevel(3)
      setLevel_ID(value.item.id)
      setCheckChangeTable(checkChangeTable + 1)
    }
  }

  return (
    <HolidayContainer>
      <div>
        {/* <div style={{ marginTop: 32, marginBottom: 32, marginLeft: 16, marginRight: 16 }}>
          <Input
            placeholder={word['Search']}
            allowClear
            suffix={<SearchOutlined style={{ fontSize: 20 }} />}
            onChange={onChange}
            size='large'
          />
        </div> */}
        <Tree
          style={{ marginLeft: 16, marginRight: 16, display: displayTree ? _ : 'none' }}
          onExpand={onExpand}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
          treeData={loop(treeCompany)}
          onClick={(e, value) => onClick(e, value)}
          selectedKeys={selectedKeys}
        />
      </div>
    </HolidayContainer>
  )
}
export default TreeComponent
